import React, { useEffect, useState } from "react";

import { MenuItem, Select } from "@mui/material";

import {
    getSignalLinkedinURL,
    postSignalAuthenticateLinkedin,
} from "helpers/Sources/linkedin";

import LoginButton from "components/molecules/LoginButton";

const LinkedinSignalDestination = ({
    setLinkedinSignalData,
    setLinkedinAuthenticated,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const [adAccounts, setAdAccounts] = useState([]);
    const [partnerInstallID, setPartnerInstallID] = useState(null);

    const [selectedAdAccount, setSelectedAdAccount] = useState(null);
    const onLoginSuccess = async (data) => {
        setIsLoading(true);
        const response = await postSignalAuthenticateLinkedin({
            code: data.code,
            state: data.state,
        });
        setAdAccounts(response?.data?.ad_accounts ?? []);
        setPartnerInstallID(response?.data?.partner_install_id ?? null);
        if (response?.status) {
            setIsAuthenticated(true);
            setLinkedinAuthenticated(true);
        } else {
            setIsAuthenticated(false);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        setLinkedinSignalData({
            selectedAdAccountReference: selectedAdAccount,
            selectedAdAccountName: adAccounts.find(
                (adAccount) => adAccount.reference === selectedAdAccount,
            )?.name,
            partnerInstallID,
        });
    }, [
        selectedAdAccount,
        partnerInstallID,
        setLinkedinSignalData,
        adAccounts,
    ]);

    return (
        <div>
            {isAuthenticated && (
                <Select
                    label="Ad Account"
                    value={selectedAdAccount}
                    onChange={(e) => setSelectedAdAccount(e.target.value)}
                    disabled={!adAccounts?.length}
                    fullWidth
                >
                    {adAccounts.map((adAccount) => (
                        <MenuItem
                            key={adAccount.reference}
                            value={adAccount.reference}
                        >
                            {adAccount.name}
                        </MenuItem>
                    ))}
                </Select>
            )}
            {!isAuthenticated && (
                <LoginButton
                    code="linkedin"
                    getAuthUrl={() =>
                        getSignalLinkedinURL().then((r) =>
                            r?.status && r?.data?.url ? r.data.url : null,
                        )
                    }
                    onAuthUrlError={() => setIsLoading(false)}
                    paramNames={["code", "state"]}
                    onSuccess={onLoginSuccess}
                    dataTransform={(params) => ({
                        code: params.code,
                        state: params.state,
                    })}
                    logoSrc="/assets/images/typeImages/lead/sources/linkedin.png"
                    buttonText="Continue with Linkedin Ads"
                    disabled={false}
                    isLoadingExternal={isLoading}
                />
            )}
        </div>
    );
};

export default LinkedinSignalDestination;
